import { useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";
import { globalModel } from "../global/GlobalModel";
import {
  extractSpaceIdFromPathname,
  readCurrentSpaceId,
  resolveLfPageTitle,
  resolveSpaceNameForId,
} from "./pageTitle";

/** 解析当前路由应对外展示的 document.title（与 H5 内导航标题解耦） */
export function useLfPageTitle(explicitSpaceName?: string | null): string {
  const { pathname } = useLocation();
  const { spaceId: routeSpaceId } = useParams<{ spaceId?: string }>();

  const spaceName = useMemo(() => {
    if (explicitSpaceName?.trim()) {
      return explicitSpaceName.trim();
    }
    const spaceId = routeSpaceId ?? extractSpaceIdFromPathname(pathname) ?? readCurrentSpaceId();
    if (!spaceId) {
      return null;
    }
    return resolveSpaceNameForId(spaceId);
  }, [
    explicitSpaceName,
    routeSpaceId,
    pathname,
    globalModel.recentSpaceEntries,
    globalModel.followSpaceCards,
  ]);

  return useMemo(() => resolveLfPageTitle(pathname, spaceName), [pathname, spaceName]);
}
